import { css } from 'react-emotion';
import { colors, animationTransition } from '../../variables';

export namespace styles {
  export const checkboxWrapper = css({
    display: 'flex',
    alignItems: 'center'
  });

  export const checkbox = (checked: boolean) =>
    css({
      position: 'relative',
      margin: 0,
      marginRight: '8px',
      display: 'inline-block',
      height: '20px',
      width: '20px',
      cursor: 'pointer',
      appearance: 'none',
      outline: 'none',
      '::before': {
        content: '" "',
        display: 'block',
        position: 'absolute',
        left: 0,
        top: 0,
        height: 20,
        width: 20,
        borderRadius: '20%',
        backgroundColor: 'white',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: colors.light
      },
      '::after': {
        opacity: checked ? 1 : 0,
        content: '" "',
        display: 'block',
        position: 'absolute',
        top: '55%',
        left: '55%',
        transform: 'translate(-50%, -50%)',
        height: 22,
        width: 22,
        borderRadius: '20%',
        backgroundColor: colors.purple_90a,
        transition: animationTransition('opacity')
      }
    });
}
